import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-branch-comission',
  templateUrl: './reports-branch-comission.component.html',
  styleUrls: ['./reports-branch-comission.component.scss']
})
export class ReportsBranchComissionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
